import React, { useEffect, useRef }from "react";
import { useNavigate } from "react-router-dom";
import { getUserInfo } from "../../services/User.js";
import { disconnectSocket } from "../../services/Socket";

import "./ProfileDropdown.css";
import xIcon from "../../assets/images/x-icon.svg";

/**
 * This is used when the user clicks on their profile picture in the top right corner of the screen.
 * @returns Profile dropdown component
 */
function ProfileDropdown ({ onClose }){
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  // Close the dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  /**
   * Handle logout by removing token from local storage and redirecting to login page
   */
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    disconnectSocket();
    navigate('/login');
  }

  /**
   * Handle settings by navigating to the settings page
   */
  const handleSettings = () => {
    navigate('/settings');
    onClose();
  };

  /**
   * Handle profile by navigating to the user's profile page
   */
  const handleProfile = () => {
    const user = getUserInfo();
    navigate(`/profile/${user.username}`);
    onClose();
  };

  return (
    <div className="profile-dropdown" ref={dropdownRef}>
      <ul>
        <li className="profile-item" onClick={handleProfile}>
          View Profile
        </li>
        <li className="profile-item" onClick={handleSettings}>
          Settings
        </li>
        <li className="profile-item" onClick={handleLogout}>
          Log out
        </li>
      </ul>
      <div className="profile-close">
        <img src={xIcon} alt="Close" className="close-icon" onClick={onClose} />
      </div>
    </div>
  );
};

export default ProfileDropdown;